import { Module, VuexModule, Mutation } from 'vuex-module-decorators'

import { OrderConfirmedQuery } from '~/graphql/types'

@Module({
  name: 'order-confirmed',
  stateFactory: true,
  namespaced: true,
})
export default class OrderConfirmed extends VuexModule {
  fetchStarted = false
  loading = true
  items: OrderConfirmedQuery['order_confirmed'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
